import { useCallback, useState } from "react";
import {
  getAccountExpansionStorageKey,
  getStoredAccountExpansion,
  storeAccountExpansion,
} from "./utils";

export const usePersistedExpansion = (
  companyId: number,
  accountKey: number | "new-account",
  enabled = true
) => {
  const storageKey = getAccountExpansionStorageKey(companyId, accountKey);
  const [expanded, setExpanded] = useState(() =>
    enabled ? getStoredAccountExpansion(storageKey) : false
  );
  const toggleExpanded = useCallback(() => {
    if (!enabled) return;
    setExpanded((current) => {
      const next = !current;
      storeAccountExpansion(storageKey, next);
      return next;
    });
  }, [enabled, storageKey]);
  return { expanded, toggleExpanded };
};
